module.exports = __webpack_public_path__ + "r.no1.3676ea15.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/kanai/female_to_male/r.no1.jpg
// module id = uppF
// module chunks = 0